import stringJson from './JournalStrings.json';


export const JournalStrings = stringJson;